import {int} from "@opendaw/lib-std"
import {bpm, MidiKeys} from "@opendaw/lib-dsp"
import {BassGenerator, BassOptions} from "./BassGenerator"
import {DrumLane} from "./DrumLane"
import {DrumOptions} from "./DrumGenerator"
import {MotionOptions} from "@/project/Motion"
import {Rng} from "./Rng"

export type AcidTrackSpec = {
    seed: int
    bpm: bpm
    lanes: ReadonlyArray<DrumLane>
    drums: DrumOptions
    bass: BassOptions
    motion: MotionOptions
}

const Scales: ReadonlyArray<MidiKeys.PredefinedScale> = [
    MidiKeys.StockScales[10], // Pentatonic Minor
    MidiKeys.StockScales[1],  // Natural Minor
    MidiKeys.StockScales[5]   // Phrygian
]

const Roots: ReadonlyArray<int> = [33, 35, 36, 38, 40]

export namespace AcidTrack {
    export const compose = (seed: int): AcidTrackSpec => {
        const rng = new Rng(seed)
        const range = (min: number, max: number): number => min + rng.next() * (max - min)
        const lanes = DrumLane.defaults()
        lanes.forEach(lane => {
            if (lane.locked) {return}
            lane.pulses = rng.nextInt(1, Math.max(1, Math.round(lane.steps * 0.6)))
            lane.rotation = rng.nextInt(0, lane.steps - 1)
            lane.accents = rng.nextInt(0, Math.max(1, lane.pulses >> 1))
            // Leaving a couple of lanes out is what keeps one track from sounding like the next.
            lane.mute = rng.next() < 0.25
        })
        return {
            seed,
            bpm: rng.nextInt(120, 125),
            lanes,
            drums: {seed, density: range(0.85, 1.25)},
            bass: {
                ...BassGenerator.defaults(),
                seed,
                patterns: 4,
                root: Roots[rng.nextInt(0, Roots.length - 1)],
                scale: Scales[rng.nextInt(0, Scales.length - 1)],
                density: range(0.6, 0.85),
                slides: range(0.15, 0.45),
                accents: range(0.2, 0.45),
                octaveJumps: range(0.05, 0.25),
                mutation: range(0.15, 0.4)
            },
            motion: {seed, enabled: true}
        }
    }
}
